// sample data from Tue Mar 12 2024
export default [
  {
    id: 13,
    name: "Australian New Zealand Clinical Trials Registry",
    badge: "ANZCTR",
    gpr_continent: "oceania",
    region_name: "Australia and New Zealand",
  },
  {
    id: 47,
    name: "Brazilian Registry of Clinical Trials",
    badge: "ReBEC",
    gpr_continent: "americas",
    region_name: "Brazil",
  },
  {
    id: 15,
    name: "Central Committee on Research Involving Human Subjects ",
    badge: "CCMO",
    gpr_continent: "europe",
    region_name: "Netherlands",
  },
  {
    id: 19,
    name: "ChiCTR/The Platform",
    badge: null,
    gpr_continent: null,
    region_name: "China",
  },
  {
    id: 34,
    name: "Chinese Clinical Trial Registry",
    badge: "ChiCTR",
    gpr_continent: "asia",
    region_name: "China",
  },
  {
    id: 21,
    name: "Clinical Research Information Service",
    badge: "CRIS",
    gpr_continent: "asia",
    region_name: "South Korea",
  },
  {
    id: 16,
    name: "Clinical Research Portal",
    badge: "KAP",
    gpr_continent: "mideast",
    region_name: "Turkey",
  },
  {
    id: 49,
    name: "Clinical Research Site - MyTrial",
    badge: "MyTrial",
    gpr_continent: "mideast",
    region_name: "Israel",
  },
  {
    id: 37,
    name: "Clinical Trials Registry",
    badge: "CTRI",
    gpr_continent: "asia",
    region_name: "India",
  },
  {
    id: 1,
    name: "ClinicalTrials.gov",
    badge: "CTG",
    gpr_continent: "americas",
    region_name: "United States",
  },
  {
    id: 44,
    name: "Cuban Public Registry of Clinical Trials",
    badge: "RPCEC",
    gpr_continent: "americas",
    region_name: "Cuba",
  },
  {
    id: 36,
    name: "Drug Clinical Trial Registration and Information Disclosure Platform",
    badge: "ChinaDrugTrials.org.cn",
    gpr_continent: "asia",
    region_name: "China",
  },
  {
    id: 9,
    name: "EU Clinical Trial Information System",
    badge: "CTIS",
    gpr_continent: "europe",
    region_name: "Europe",
  },
  {
    id: 3,
    name: "EU PAS - ENCePP (European Network of Centres for Pharmacoepidemiology and Pharmacovigilance [PASS & PAES requirements])",
    badge: "EU PAS",
    gpr_continent: "europe",
    region_name: "Europe",
  },
  {
    id: 31,
    name: "EMA RWD - ENCePP (European Network of Centres for Pharmacoepidemiology and Pharmacovigilance [PASS & PAES requirements])",
    badge: "EMA RWD",
    gpr_continent: "europe",
    region_name: "Europe",
  },
  {
    id: 2,
    name: "European Union Drug Regulating Authorities Clinical Trials Database",
    badge: "EudraCT",
    gpr_continent: "europe",
    region_name: "Europe",
  },
  {
    id: 8,
    name: "German Clinical Trials Register",
    badge: "DRKS",
    gpr_continent: "europe",
    region_name: "Germany",
  },
  {
    id: 40,
    name: "HSA Clinical Trial Register",
    badge: "HSACTR",
    gpr_continent: "asia",
    region_name: "Singapore",
  },
  {
    id: 20,
    name: "Health Canada Database",
    badge: "Health Canada",
    gpr_continent: "americas",
    region_name: "Canada",
  },
  {
    id: 55,
    name: "Health Research Authority",
    badge: "HRA",
    gpr_continent: "europe",
    region_name: "United Kingdom",
  },
  {
    id: 12,
    name: "ISRCTN/HRA",
    badge: null,
    gpr_continent: null,
    region_name: "United Kingdom",
  },
  {
    id: 54,
    name: "International Standard Registered Clinical/Social Study Number",
    badge: "ISRCTN",
    gpr_continent: "europe",
    region_name: "United Kingdom",
  },
  {
    id: 38,
    name: "Japan Registry for Clinical Trials",
    badge: "jRCT",
    gpr_continent: "asia",
    region_name: "Japan",
  },
  {
    id: 39,
    name: "Japanese Pharmaceutical Information Center Clinical Trials Information",
    badge: "JapicCTI",
    gpr_continent: "asia",
    region_name: "Japan",
  },
  {
    id: 50,
    name: "Lebanon Clinical Trials Registry",
    badge: "LBCTR",
    gpr_continent: "mideast",
    region_name: "Lebanon",
  },
  {
    id: 6,
    name: "Ministry of Food and Drug Safety",
    badge: "MFDS",
    gpr_continent: "asia",
    region_name: "South Korea",
  },
  {
    id: 7,
    name: "NTR",
    badge: null,
    gpr_continent: null,
    region_name: "Netherlands",
  },
  {
    id: 18,
    name: "National Registry for Clinical Studies",
    badge: "RNEC(Portugal)",
    gpr_continent: "europe",
    region_name: "Portugal",
  },
  {
    id: 45,
    name: "National Registry of Clinical Trials",
    badge: "RNEC",
    gpr_continent: "americas",
    region_name: "Mexico",
  },
  {
    id: 46,
    name: "National Registry of Health Research",
    badge: "ReNIS",
    gpr_continent: "americas",
    region_name: "Argentina",
  },
  {
    id: 48,
    name: "Peruvian Clinical Trial Registry",
    badge: "REPEC",
    gpr_continent: "americas",
    region_name: "Peru",
  },
  {
    id: 10,
    name: "PharmNet.Bund",
    badge: "PharmNet.Bund",
    gpr_continent: "europe",
    region_name: "Germany",
  },
  {
    id: 42,
    name: "Philippine Health Research Registry",
    badge: "PHRR",
    gpr_continent: "asia",
    region_name: "Philippines",
  },
  {
    id: 17,
    name: "REeC",
    badge: null,
    gpr_continent: null,
    region_name: "Spain",
  },
  {
    id: 51,
    name: "Saudi Clinical Trials Registry",
    badge: "SCTR",
    gpr_continent: "mideast",
    region_name: "Saudi Arabia",
  },
  {
    id: 5,
    name: "South African National Clinical Trials Register",
    badge: "SANCTR",
    gpr_continent: "africa",
    region_name: "South Africa",
  },
  {
    id: 53,
    name: "Spanish Registry of Clinical Studies",
    badge: "Reec",
    gpr_continent: "europe",
    region_name: "Spain",
  },
  {
    id: 4,
    name: "Sponsor Website",
    badge: "Sponsor Website",
    gpr_continent: "Internal",
    region_name: "Internal",
  },
  {
    id: 52,
    name: "State Register of Medicine",
    badge: "GRLS",
    gpr_continent: "europe",
    region_name: "Russia",
  },
  {
    id: 14,
    name: "Swiss National Clinical Trials Portal ",
    badge: "SNCTP",
    gpr_continent: "europe",
    region_name: "Switzerland",
  },
  {
    id: 41,
    name: "Taiwan Drug Clinical Trial Information Network",
    badge: "TDCTIN",
    gpr_continent: "asia",
    region_name: "Taiwan",
  },
  {
    id: 43,
    name: "Thai Clinical Trials Registry",
    badge: "TCTR",
    gpr_continent: "asia",
    region_name: "Thailand",
  },
  {
    id: 35,
    name: "The Platform",
    badge: "The Platform",
    gpr_continent: "asia",
    region_name: "China",
  },
  {
    id: 11,
    name: "jrCT/JapicCTI",
    badge: null,
    gpr_continent: null,
    region_name: "Japan",
  },
]
